import React from 'react';
import { EAA_Item, EAA_ItemContainer, EAA_Select, EAA_Row, EAA_TitleText, EAA_Input, EAA_ErrorText, EAA_Add_Btn, EAA_Memo, EAA_Date } from '~/components/EditAndAddItem';
import * as getTime from '~/skills/getTime';

const emptyBody = {
  start_date: '',
  end_date: '',
};

const App = props => {
  const { titleWidth, disabled, checkChange, changeData, data, errorAry = [], errorLeft } = props;
  const ary = data.sub2 || [];
  if (ary.length === 0)ary.push({ ...emptyBody });

  const saveSub = dataAry => {
    changeData({ label: 'sub2', data: dataAry });
  };

  const addRow = () => {
    ary.push({ ...emptyBody });
    saveSub(ary);
  };

  const delRow = n => {
    ary.splice(n, 1);
    saveSub(ary);
  };

  const renderAry = [];
  for (let i = 0; i < ary.length; i++) {
    const isFirst = i === 0;
    renderAry.push(
      <EAA_Row key={`Page_ForeignBoat_sub2_1_${i}`}>
        <EAA_Item>
          <EAA_ItemContainer>
            <EAA_TitleText width={titleWidth} text='' />
            <div style={{ flex: 1, fontSize: 16, fontWeight: 400, color: 'rgba(0, 0, 0, 0.54)', marginRight: 12 }}>{isFirst && '規劃送件日期'}</div>
            <div style={{ flex: 1, fontSize: 16, fontWeight: 400, color: 'rgba(0, 0, 0, 0.54)', marginRight: 12 }}>擬申請船期起始</div>
            <div style={{ flex: 1, fontSize: 16, fontWeight: 400, color: 'rgba(0, 0, 0, 0.54)', marginRight: 12 + 150 }}>擬申請船期結束</div>
          </EAA_ItemContainer>
        </EAA_Item>
      </EAA_Row>,
    );
    renderAry.push(
      <EAA_Row key={`Page_ForeignBoat_sub2_2_${i}`} style={{ marginTop: 0 }}>
        <EAA_Item>
          <EAA_ItemContainer>
            <EAA_TitleText width={titleWidth} text={isFirst ? '擬申請船期' : ''} bol={isFirst} haveChange={checkChange('apply_sail_date')} />
            {isFirst && <EAA_Date displayBorder disabled={disabled} marginRight={8} value={getTime.returnDate(data.apply_sail_date)} onChange={data => changeData({ label: 'apply_sail_date', data: getTime.getType3Time(data) })} />}
            {!isFirst && <div style={{ flex: 1, marginRight: 8 }} />}
            <EAA_Date displayBorder disabled={disabled} marginRight={8} value={getTime.returnDate(ary[i].start_date)} onChange={data => { ary[i].start_date = getTime.getType3Time(data); saveSub(ary); }} />
            <EAA_Date displayBorder disabled={disabled} marginRight={8} value={getTime.returnDate(ary[i].end_date)} onChange={data => { ary[i].end_date = getTime.getType3Time(data); saveSub(ary); }} />
            <EAA_Add_Btn disabled={disabled} del={i > 0} onClick={(i > 0) ? () => delRow(i) : () => addRow()} />
          </EAA_ItemContainer>
          {isFirst && errorAry[9] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇『規劃送件日期』' />}
        </EAA_Item>
      </EAA_Row>,
    );
  }
  return renderAry;
};
export default App;
